ACC.myprofile = {

  bindAll: function() {
    this.bindChangepasswordLink($('.ph-myprofile-changepassword'));
    $('.ph-change-currency').on('click', function() {
      $('select').selectBox('destroy');
      ACC.myprofile.changeCurrencyOrLanguagePopup('currency');
    });
    $('.ph-changelanguage_profile').on('click', function() {
      $('select').selectBox('destroy');
      ACC.myprofile.changeCurrencyOrLanguagePopup('language');
    });

    $(document).on('click', '#cboxContent .ph-changepwd-cancel', function() {
      if ($('.ph-isOneStore').html() === 'true' && $('.pageLabel-profile').length === 0) {
        if (sessionStorage.getItem('cartReminderPopup') === 'shown') {
          $.colorbox.close();
        } else {
          ACC.cartReminder.cartReminderPopupSubFunction();
        }
      } else {
        $.colorbox.close();
      }
    });
  },

  profileDetails: function() {
    $(document).on('click', '.ph-myprofile-editdetails', function() {
      ACC.myprofile.editProfile($(this));
    });
  },

  editProfile: function(obj) {
    $.colorbox({
      html: obj.parent().siblings('.ph-myprofile__editdetailspopup').html(),
      maxWidth: '500px',
      width: '100%',
      height: '100%;',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('#globalMessages').text('');
        $('.ph-optinlink ').click(function() {
          $.colorbox({
            maxWidth: '700px',
            width: '100%',
            scrolling: true,
            html: $('.ph-PopUpText').html(),
            close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
            onComplete: function() {
              ACC.common.refreshScreenReaderBuffer();

              /* eslint-disable  init-declarations */
              var topPos;

              /* eslint-enable  init-declarations */
              if ($('.ph-optinsectionpopup').offset() !== null) {
                topPos = $('.ph-optinsectionpopup').offset().top;
              }

              if ($('.pageLabel-profile').length > 0) {
                $('#colorbox').css('top', topPos);
              }
            },
            onClosed: function() {
              ACC.myprofile.editProfile($('.ph-myprofile-editdetails'));
            }
          });
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  voucherAlertDisplay: function() {
    var voucherAlert = false,
        $currencyPopup = $('#cboxWrapper');

    if ($('.ph-isVoucherApplied').html() === 'true' &&
     ($currencyPopup.find('#currency-selector').val() !== $('.ph-currentCurrency').html())) {
      $currencyPopup.find('.ph-voucherAlert').show();
      voucherAlert = true;
    } else {
      $currencyPopup.find('.ph-voucherAlert').hide();
    }

    return voucherAlert;
  },
  changeCurrencyOrLanguagePopup: function(popupReason) {
    var colorboxHtmlContentClass = '';

    if (popupReason === 'currency') {
      colorboxHtmlContentClass = '.ph-currency-selector';
    } else if (popupReason === 'language') {
      colorboxHtmlContentClass = '.ph-language_selector';
    }

    $.colorbox({
      html: $(colorboxHtmlContentClass).html(),
      width: '100%',
      maxWidth: 540,
      height: '80%',
      maxHeight: 230,
      top: 50,
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        $('select').selectBox();
        ACC.common.refreshScreenReaderBuffer();
        ACC.common.refreshSelectBoxArrow();
        $(document).on('click', '.js-language_updatebuttons a,.js-currency_updatebuttons a', function() {
          $.colorbox.close();
        });
        $(document).on('change', '#cboxWrapper #language_selector,#cboxWrapper #currency-selector', function() {
          var heightVal = 230;

          if (ACC.myprofile.voucherAlertDisplay()) {
            heightVal = 270;
          }

          $.colorbox.resize({
            height: heightVal
          });
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  bindChangepasswordLink: function(link) {
    link.click(function() {
      $.get(link.data('url')).done(function(data) {
        $.colorbox({
          html: data,
          maxWidth: '500px',
          width: '100%',
          height: '75%;',
          overlayClose: false,
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          onOpen: function() {
            $('#validPassword').remove();
          },
          onComplete: function() {
            $('#globalMessages').text('');

            if (navigator.appVersion.indexOf('Edge') !== -1) {
              $('.ph-formlabel').addClass('ph-formlabeledge');
            }

            ACC.profile.changePassword();

            var $changedPwdForm = $('#updatePasswordForm');

            $changedPwdForm.ajaxForm({
              success: function(result) {
                /* eslint-disable  unicorn/explicit-length-check */
                if ($(result).closest('#validPassword').length) {
                  /* eslint-enable  unicorn/explicit-length-check */
                  if ($('#validPassword').length === 0) {
                    $('#globalMessages').append(result);
                  }

                  $.colorbox.close();
                } else {
                  $changedPwdForm.find('.ph-page-profile').html($(result).find('#updatePasswordForm .ph-page-profile'));
                  $('#update-password').attr('disabled', true);

                  if (navigator.appVersion.indexOf('Edge') !== -1) {
                    $('.ph-formlabel').addClass('ph-formlabeledge');
                  }

                  ACC.profile.changePassword();
                }
              }
            });
            ACC.common.refreshScreenReaderBuffer();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });
    });
  },

  /* eslint-disable max-statements */
  validateUpdateProfileForm: function() {
    /* eslint-enable max-statements */
    var count = 0;

    $('#cboxContent #updateProfileForm .form_field-input').each(function() {
      var inputId = $(this).attr('id'),
          inputValue = $(this).find('input').val(),
          errormsgValue = $('#' + inputId).attr('data-emptyContent');

      /* eslint-disable no-undefined*/
      if (inputValue === '' || inputValue === null || inputValue === undefined || $.trim(inputValue) === '') {
        /* eslint-enable no-undefined*/
        count = count + 1;
        $('#cboxContent #' + inputId).find('.ph-form__fieldwrap').addClass('form_field_error ph-form_field_error');
        $('#cboxContent #' + inputId).find('.ph-register__emptyvalue').text(errormsgValue);
      } else {
        $('#cboxContent #' + inputId).find('.ph-form__fieldwrap').removeClass('form_field_error ph-form_field_error');
        $('#cboxContent #' + inputId).find('.ph-register__emptyvalue').text('');
      }
    });

    if (ACC.validation.userName($.trim($('#cboxContent #profileFirstName input').val()))) {
      count = count + 1;
      $('#cboxContent #profileFirstName').find('.ph-form__fieldwrap').addClass('form_field_error ph-form_field_error');
      $('#cboxContent #profileFirstName').find('.ph-register__emptyvalue').text($('#cboxContent #profileFirstName').attr('data-emptyContent'));
    }

    if (ACC.validation.userName($.trim($('#cboxContent #profileLastName input').val()))) {
      count = count + 1;
      $('#cboxContent #profileLastName').find('.ph-form__fieldwrap').addClass('form_field_error ph-form_field_error');
      $('#cboxContent #profileLastName').find('.ph-register__emptyvalue').text($('#cboxContent #profileLastName').attr('data-emptyContent'));
    }

    if (ACC.validation.userName($.trim($('#cboxContent #profileTitle input').val()))) {
      count = count + 1;
      $('#cboxContent #profileTitle').find('.ph-form__fieldwrap').addClass('form_field_error ph-form_field_error');
      $('#cboxContent #profileTitle').find('.ph-register__emptyvalue').text($('#cboxContent #profileTitle').attr('data-emptyContent'));
    }

    if (ACC.validation.phoneNumber($.trim($('#cboxContent #profilePhoneNumber input').val()))) {
      count = count + 1;
      $('#cboxContent #profilePhoneNumber').find('.ph-form__fieldwrap').addClass('form_field_error ph-form_field_error');
      $('#cboxContent #profilePhoneNumber').find('.ph-register__emptyvalue').text($('#cboxContent #profilePhoneNumber').attr('data-emptyContent'));
    }

    if (count === 0) {
      return true;
    }

    return false;
  }

};

$(document).ready(function() {
  ACC.myprofile.bindAll();
  ACC.myprofile.profileDetails();
  $('.ph-profilepage__horizontalline:last').css('visibility', 'hidden');

  if ($('.ph-page-profile').length > 0 && $('.ph-asmUserFlag').html() === 'true') {
    $('.marketingPreference').prop('disabled', 'disabled');
  }
});
